module.exports = __webpack_public_path__ + "img/error.6f943e94.png";